var map = {
	"./bgDashbord1.png": 19465,
	"./login/encuesta-portada.png": 22106,
	"./login/logo.png": 5927,
	"./logo-simple-soofia.png": 80622,
	"./logo.png": 33153,
	"./logoYo.png": 49785,
	"./logo_yo.png": 29642,
	"./soofia.png": 46743,
	"./yo_white.png": 20122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50715;